import { Chapter, CommunityFeed } from '@/types'
import { WebInputFile } from '@codeleap/common'
import { globalState } from '@codeleap/store'

type StoreValue = {
  type?: 'photo' | 'text' | 'video'
  file?: WebInputFile
  prompt?: CommunityFeed['prompt']
  lesson?: Chapter['id']
}

export const state = globalState<StoreValue>({
  type: null,
  file: null,
  prompt: null,
  lesson: null,
})
